import React, { useState, useEffect } from 'react'
import { Box } from "@mui/material";
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';

const LocationPicker = (props) => {
    const [location, setLocation] = useState({ lat: 0.0, lng: 0.0 });
    const [zoom, setZoom] = useState(10);
    const { onChangeLocation, LocationValue } = props;

    const style = {
        width: '100%',
        height: '300px',
        position: 'relative',
    }

    const containerStyle = {
        width: '100%',
        height: '300px',
        position: 'relative',
    }

    const handleMapClick = (mapProps, map, clickEvent) => {
        setLocation({ lat: clickEvent.latLng.lat(), lng: clickEvent.latLng.lng() });
    };

    const handleMarkerDragend = (props, map, clickEvent) => {
        setLocation({ lat: clickEvent.latLng.lat(), lng: clickEvent.latLng.lng() });
    };

    const handleZoomChanged = (props, map) => {
        setZoom(map.zoom);
    };

    useEffect(() => {
        onChangeLocation({ ...location, zoom });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, zoom])

    useEffect(() => {
        if (LocationValue) {
            const newLocation = JSON.parse(LocationValue);
            setLocation({ lat: newLocation?.lat, lng: newLocation?.lng });
            setZoom(newLocation?.zoom)
        } else {
            axios.get('https://ipapi.co/json/').then((response) => {
                let data = response.data;
                setLocation({lat:  data.latitude, lng: data.longitude})
            }).catch((error) => {
                console.log(error);
            });

        }

    }, [LocationValue])


    return (
        <Box sx={{ borderRadius: '16px', overflow: 'hidden', mb: 3 }}>
            <Map
                google={props.google}
                zoom={zoom}
                onZoomChanged={handleZoomChanged}
                style={style}
                containerStyle={containerStyle}
                onClick={handleMapClick}
                center={location}
            >
                <Marker
                    position={location}
                    name={'Current location'}
                    draggable
                    onDragend={handleMarkerDragend}
                />
            </Map>
        </Box>
    );

}

export default GoogleApiWrapper({
    apiKey: (process.env.REACT_APP_GOOGLE_MAPS_API_KEY)
})(LocationPicker);
